import React from 'react';
import { makeStyles } from '@material-ui/styles';
import { HiOutlineDocumentReport } from 'react-icons/all';
import CollectionItemHeader from '../layout/CollectionItemHeader';
import getTheme from '../../theme/theme';
import AssociationReportsResolver from './association-reports/AssociationReportsResolver';
import useAssociationReports from '../../hooks/association-reports-hooks';

const useStyles = makeStyles((theme) => {
  return {
    root: {
      minWidth: 275,
    },
    bullet: {
      display: 'inline-block',
      margin: theme.spacing(0, 1),
      transform: 'scale(0.8)',
    },
    title: {
      fontSize: 14,
    },
    pos: {
      marginBottom: theme.spacing(1),
    },
    demo: {
      backgroundColor: '#f0f0f0',
      alignItems: 'center',
      marginLeft: '5%',
      marginRight: '5%',
    },
  };
});

const AssociationReports = () => {
  const classes = useStyles();

  const {
    count,
    countLoading,
  } = useAssociationReports();

  return (
    <>
      <div className={ classes.root }>
        <div style={ { display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: getTheme().spacing(2) } }>
          <HiOutlineDocumentReport
            style={ { color: getTheme().palette.secondary.dark, marginRight: getTheme().spacing(2) } }
            size={ 36 }
          />
          <CollectionItemHeader
            title='Association Reports'
            subtitle={ countLoading ? ' ' : `Total entries: ${ count }` }
            actions={ (
              <>
              </>
            ) }
          />
        </div>
        <AssociationReportsResolver />
      </div>
    </>
  );
};

export default AssociationReports;
